import React from 'react';

import { PublicClientApplication } from '@azure/msal-browser';
import ReactDOM from 'react-dom';

import App from './App';
import { msalConfig } from './config/app-config';

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <React.StrictMode>
    <App pca={msalInstance} />
  </React.StrictMode>,
  document.getElementById('root')
);
